import { apiHelper } from './api_helper';

export const DM_CAUHINH_EMAIL_API_END_POINT = "dm-cauhinh-email";
export const dmCauHinhEmailApi = {
  SelectAll: () => apiHelper.get(`${DM_CAUHINH_EMAIL_API_END_POINT}`),
  Detail: (id) => apiHelper.get(`${DM_CAUHINH_EMAIL_API_END_POINT}/${id}`),
  Insert: (data) => apiHelper.post(`${DM_CAUHINH_EMAIL_API_END_POINT}`, data),
  Update: (data) => apiHelper.put(`${DM_CAUHINH_EMAIL_API_END_POINT}`, data),
  Delete: (id) => apiHelper.delete(`${DM_CAUHINH_EMAIL_API_END_POINT}/${id}`),
}